<template>
  <div class="page-content">
    <div class="container-fixed">
      <!-- 头部区域 -->
      <header class=" bg-gradient-primary header-gradient text-white py-20 px-6 md:px-12">
        <div class="max-w-5xl mx-auto text-center">
          <h1 class="text-4xl md:text-5xl font-bold mb-6">行业交流</h1>
          <div class="text-lg text-white/90 max-w-3xl mx-auto">
            <p>促进会展行业深度交流与合作，搭建信息共享与资源对接桥梁，汇聚行业精英、分享前沿动态、分析市场趋势，共同推动会展行业创新发展与转型升级。</p>
          </div>
        </div>
      </header>

      <!-- 功能入口区域 -->
      <section class="py-16 px-6 md:px-12">
        <div class="max-w-7xl mx-auto">
          <!-- 上面三个功能入口 -->
          <div class="features-grid-top flex flex-wrap justify-center gap-6 mb-8">
            <!-- 视频中心 -->
            <div class="feature-card flex-1 min-w-[250px] max-w-[350px]" @click="openRouter('/video-center/home')">
              <div class="feature-icon">
                <i class="fas fa-video"></i>
              </div>
              <h3 class="text-xl font-bold mb-2">视频中心</h3>
              <p class="text-gray-600">汇聚行业峰会、论坛演讲、展会现场等精彩视频内容，随时随地获取行业前沿知识与实践经验。</p>
            </div>

            <!-- 展会报告 -->
            <div class="feature-card flex-1 min-w-[250px] max-w-[350px]" @click="openRouter('/meeting-report/home')">
              <div class="feature-icon">
                <i class="fas fa-file-alt"></i>
              </div>
              <h3 class="text-xl font-bold mb-2">展会文集</h3>
              <p class="text-gray-600">提供全面的展会数据分析、行业趋势洞察与市场预测，帮助企业把握会展行业发展脉搏。</p>
            </div>

            <!-- 产业图谱 -->
            <div class="feature-card flex-1 min-w-[250px] max-w-[350px]" @click="openRouter('/industry-chat/home')">
              <div class="feature-icon">
                <i class="fas fa-project-diagram"></i>
              </div>
              <h3 class="text-xl font-bold mb-2">产业图谱</h3>
              <p class="text-gray-600">直观展示会展产业链全景，包括上下游企业分布、关联产业互动及市场竞争格局。</p>
            </div>
          </div>

          <!-- 下面四个功能入口 -->
          <div class="features-grid-bottom flex flex-wrap justify-center gap-6">
            <!-- 招投标信息 -->
            <div class="feature-card flex-1 min-w-[250px] max-w-[300px]" @click="openRouter('/ztbxx/home')">
              <div class="feature-icon">
                <i class="fas fa-gavel"></i>
              </div>
              <h3 class="text-xl font-bold mb-2">招投标信息</h3>
              <p class="text-gray-600">实时更新国内外会展项目招标与投标信息，提供项目详情、截止日期及联系方式。</p>
            </div>

            <!-- 大都月刊 -->
            <div class="feature-card flex-1 min-w-[250px] max-w-[300px]" @click="openRouter('/monthly/home')">
              <div class="feature-icon">
                <i class="fas fa-book"></i>
              </div>
              <h3 class="text-xl font-bold mb-2">大都月刊</h3>
              <p class="text-gray-600">每月精选行业热点、深度分析与案例研究，提供权威的政策解读与专家观点。</p>
            </div>

            <!-- 会展朋友圈 -->
            <div class="feature-card flex-1 min-w-[250px] max-w-[300px]">
              <div class="feature-icon">
                <i class="fas fa-users"></i>
              </div>
              <h3 class="text-xl font-bold mb-2">会展朋友圈</h3>
              <p class="text-gray-600">搭建会展行业人脉交流平台，促进同行互动、经验分享与业务合作，拓展行业资源网络。</p>
            </div>

            <!-- 招聘专区 -->
            <div class="feature-card flex-1 min-w-[250px] max-w-[300px]">
              <div class="feature-icon">
                <i class="fas fa-briefcase"></i>
              </div>
              <h3 class="text-xl font-bold mb-2">招聘专区</h3>
              <p class="text-gray-600">汇聚行业优质职位与专业人才，提供精准的人才匹配服务，助力企业与人才共同成长。</p>
            </div>
          </div>
        </div>
      </section>

    </div>
  </div>
</template>
<script>
export default {
  name: "HyjlHome",
  methods: {
    openRouter(url) {
      const {href} = this.$router.resolve({
        path: url,
      });
      window.open(href, '_self', 'noopener');
    }
  }
}
</script>

<style scoped>
body {
  font-family: 'Noto Sans SC', sans-serif;
  background-color: #f0f7ff;
  color: #2d3748;
  overflow-x: hidden;
}

.bg-gradient-primary {
  background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
  border-radius: 20px 20px 0px 0px;
  margin-bottom: 20px;
}

.container-fixed {
  max-width: 1920px;
  margin: 0 auto;
  position: relative;
  margin-top: 20px;
}

.feature-card {
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.7);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  padding: 2rem;
  border: 1px solid rgba(226, 232, 240, 0.8);
  min-height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
}

.feature-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  background-color: #e0f2fe;
  color: #1e40af;
  font-size: 1.5rem;
}

@media (max-width: 1200px) {
  .features-grid-top,
  .features-grid-bottom {
    flex-wrap: wrap;
  }

  .feature-card {
    flex: 0 0 calc(50% - 1rem);
    margin-bottom: 1.5rem;
  }
}

@media (max-width: 768px) {
  .feature-card {
    flex: 0 0 100%;
  }
}
</style>
